module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Browse More Profiles")]), _vm._v(" "), _c('div', {
    staticClass: "more-profiles"
  }, _vm._l((_vm.browseMembers), function(member) {
    return _c('div', {
      staticClass: "profile-link"
    }, [_c('a', {
      attrs: {
        "href": ("/Profile/" + (member.stringUrl))
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.avatarImage(member)
      }
    }), _c('span', {
      staticClass: "member-name"
    }, [_vm._v(_vm._s(member.alias))])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54c68845"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ProfilePage/BrowseMoreProfiles.vue
// module id = 401
// module chunks = 1